import { Aux } from './AuxillaryServices';
import { $ } from '../../vendor/jquery';
import _ from 'underscore';

function NetworkService() {
    var t = this;

    t.m_QueryPromise = null;
    t.m_Cancel = false;
    t.m_LastStatus = null;
    t.m_Callbacks = {
        statusChanged: {},
    };

    this.registerCallback = function (eventName, callbackName, callback) {
        if (typeof t.m_Callbacks[eventName] !== 'undefined') {
            t.m_Callbacks[eventName][callbackName] = callback;
        }
    };

    this.unregisterCallback = function (eventName, callbackName) {
        if (
            typeof t.m_Callbacks[eventName] !== 'undefined' &&
            t.m_Callbacks[eventName][callbackName] !== 'undefined'
        ) {
            delete t.m_Callbacks[eventName][callbackName];
        }
    };

    this.onDiscoveryComplete = function (enable) {
        if (enable) {
            beginMonitoring();
        } else {
            suspendMonitoring();
        }
    };

    function processResult(data) {
        if (
            typeof data !== 'undefined' &&
            typeof data.value !== 'undefined' &&
            data.value !== t.m_LastStatus
        ) {
            _.each(t.m_Callbacks.statusChanged, function (callback) {
                try {
                    callback(data.value, t.m_LastStatus);
                } catch (e) {
                    // The original developer failed to document what exception
                    // they were trying to catch, so it is unknown why this
                    // try/catch block is here.
                }
            });

            t.m_LastStatus = data.value;
        }
    }

    function queryCache() {
        var promise = $.ajax({
            url: 'https://localhost:8082/Cache/WaitForChange/NetworkStatus',
            type: 'GET',
            dataType: 'json',
            timeout: 30000,
            success: function (data) {
                processResult(data);
                setTimeout(onQueryComplete, 0);
            },
            error: function () {
                setTimeout(onQueryComplete, 0);
            },
        });

        //it is within the realm of possibility that the network status changed
        //between the time queryCache last resolved and we were able to initiate
        //a new query to local cache. chances are almost nil, but still, it is
        //possible
        $.ajax({
            url: 'https://localhost:8082/Cache/NetworkStatus',
            type: 'GET',
            dataType: 'json',
            timeout: 1000,
            success: function (data) {
                processResult(data);
            },
        });

        return promise;
    }

    function onQueryComplete() {
        t.m_QueryPromise = null;

        if (!t.m_Cancel) {
            t.m_QueryPromise = queryCache();
        }
    }

    function beginMonitoring() {
        t.m_Cancel = false;

        if (null === t.m_QueryPromise) {
            t.m_QueryPromise = queryCache();
        }
    }

    function suspendMonitoring() {
        t.m_Cancel = true;
    }
}

function NetworkBase() {}

NetworkBase.m_Loaded = false;
NetworkBase.Mechanism = null;

NetworkBase.onServiceDiscovered = function (event, param) {
    switch (event) {
        case 'Initialize': {
            if (!NetworkBase.Mechanism) {
                NetworkBase.Mechanism = new NetworkService();

                Aux.RegisterService('Network', NetworkBase.Mechanism);
            }

            break;
        }
        case 'ServicesDiscovered': {
            if (_.contains(param, 'REACH.Cache')) {
                NetworkBase.Mechanism.onDiscoveryComplete(true);
            }

            break;
        }
        case 'DiscoveryFailed': {
            NetworkBase.Mechanism.onDiscoveryComplete(false);

            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeNetwork() {
    Aux.AddListener(NetworkBase.onServiceDiscovered);
}

export { initializeNetwork };
